import React, { useEffect, useState } from "react";
import "./App.css";
import axios from "axios";
import { Toaster } from "./components/ui/sonner";
import { toast } from "sonner";

// Components Pubblici
import { Navbar } from "./components/Navbar";
import { HeroSection } from "./components/HeroSection";
import { EventsSection } from "./components/EventsSection";
import { AboutSection } from "./components/AboutSection";
import { GallerySection } from "./components/GallerySection";
import { RulesSection } from "./components/RulesSection";
import { ContactSection } from "./components/ContactSection";
import { Footer } from "./components/Footer";

// Components Admin (Assicurati di aver creato questi file)
import { AdminLogin } from "./components/AdminLogin";
import { AdminDashboard } from "./components/AdminDashboard";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Stato per l'autenticazione Admin
  const [token, setToken] = useState(localStorage.getItem("adminToken"));
  const [hash, setHash] = useState(window.location.hash);

  // Monitora il cambio di URL (per entrare/uscire da #admin)
  useEffect(() => {
    const handleHashChange = () => setHash(window.location.hash);
    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  const fetchEvents = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API}/events`);
      setEvents(response.data); // rimuovere pre attivare il ritardo
      {/*// PROVA RITARDO CARICAMENTO SKELETON
      setTimeout(() => {
        setEvents(response.data);
        setLoading(false);
      }, 2000); // 3000 millisecondi = 3 secondi
      // FINO A QUA */}
    } catch (e) {
      console.error("Errore nel recupero eventi:", e);
      toast.error("Errore di connessione", {
        description: "Impossibile recuperare gli eventi dal database.",
      });
    } finally { // rimuovere per attivare ritardo skeleton
      setLoading(false);
    }
  };

  const submitApplication = async (applicationData) => {
    // SICUREZZA: Pulizia dati (Mass Assignment Protection)
    const sanitizedData = {
      event_id: applicationData.event_id,
      team_name: applicationData.team_name?.trim(),
      operators_count: parseInt(applicationData.operators_count),
      contact_email: applicationData.contact_email?.trim(),
      contact_phone: applicationData.contact_phone?.trim(),
      notes: applicationData.notes?.substring(0, 500) // Limite caratteri
    };

    try {
      await axios.post(`${API}/applications`, sanitizedData);
      toast.success("Candidatura inviata!", {
        description: "Il Comando Ghost Division ha ricevuto i dati della tua squadra.",
      });
      return true;
    } catch (e) {
      console.error("Errore invio candidatura:", e);
      if (e.response) {
        if (e.response.status === 429) {
          toast.error("Troppe richieste", { description: "Aspetta un minuto prima di riprovare." });
        } else if (e.response.status === 422) {
          toast.error("Dati non validi", { description: "Controlla i campi inseriti." });
        } else {
          toast.error("Errore del server");
        }
      } else {
        toast.error("Errore di rete");
      }
      return false;
    }
  };

  const submitContact = async (contactData) => {
    try {
      // const FORMSPREE_URL = "https://formspree.io/f/mgoloeej";
      // await axios.post(FORMSPREE_URL, contactData);
      await axios.post(`${API}/contact`, contactData);
      toast.success("Messaggio inviato!", {
        description: "Il Comando ha ricevuto la tua richiesta.",
      });
      return true;
    } catch (e) {
      console.error("Errore invio contatto:", e);
      toast.error("Errore critico", { description: "Servizio mail non raggiungibile." });
      return false;
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    setToken(null);
    window.location.hash = ""; 
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  // --- LOGICA DI RENDERING ---
  
  // Se l'URL contiene #admin, mostriamo l'area riservata
  if (hash === "#admin") {
    return (
      <div className="App admin-mode">
        {!token ? (
          <AdminLogin onLoginSuccess={(t) => setToken(t)} />
        ) : (
          <AdminDashboard 
          token={token} 
          onLogout={handleLogout} 
          refreshGlobalEvents={fetchEvents}
          />
        )}
        <Toaster position="bottom-right" />
      </div>
    );
  }

  // Altrimenti, mostriamo il sito pubblico normale
  return (
    <div className="App">
      <div className="noise-overlay" aria-hidden="true"></div>
      
      <Navbar />
      
      <main>
        <HeroSection />
        <EventsSection 
          events={events} 
          loading={loading} 
          onSubmitApplication={submitApplication}
        />
        <AboutSection />
        <GallerySection />
        <RulesSection />
        <ContactSection onSubmitContact={submitContact} />
      </main>
      
      <Footer />
      
      <Toaster 
        position="bottom-right"
        toastOptions={{
          style: {
            background: '#0F0F11',
            border: '1px solid #27272A',
            color: '#EDEDED',
          },
        }}
      />
    </div>
  );
}

export default App;